const BANNER_DISMISSED_UNTIL_KEY = 'saloni-pwa-install-banner-dismissed-until';
const DEFAULT_DISMISS_FOR_MS = 60 * 60 * 1000; // 1 hour

export function wasPwaInstallBannerDismissed() {
  try {
    const raw = window.localStorage.getItem(BANNER_DISMISSED_UNTIL_KEY);
    const until = raw ? Number(raw) : 0;
    if (!Number.isFinite(until) || until <= 0) return false;
    return Date.now() < until;
  } catch {
    return false;
  }
}

export function dismissPwaInstallBanner(dismissForMs = DEFAULT_DISMISS_FOR_MS) {
  try {
    window.localStorage.setItem(
      BANNER_DISMISSED_UNTIL_KEY,
      String(Date.now() + (Number.isFinite(dismissForMs) ? dismissForMs : DEFAULT_DISMISS_FOR_MS)),
    );
  } catch {
    /* ignore */
  }
}
